<template>
  <MainLayout page-title="外采入库" @listen-back="goBack" customBack>
    <div slot="main-content" class="main-content">
      <el-form
        :model="ruleForm"
        :rules="rules"
        inline
        ref="ruleForm"
        label-width="130px"
        class="ruleForm Outsourcing"
      >
        <el-form-item label="农产品" prop="cropId">
          <originalSelect
            :backDate.sync="ruleForm.cropId"
            :backisShowDate.sync="isShow"
            :optionList="option"
            :loading="loading"
            leftLabel="cropName"
            rightLabel="cropAliasName"
            @addNewkind="addOption"
            @backObjData="backObjData"
            placeholder="作物、禽畜、水产"
            searchPlaceholder="搜索作物、禽畜或水产"
            class="select_width"
          >
          </originalSelect>
        </el-form-item>
        <el-form-item label="入库类型" prop="farmProduceType">
          <el-radio-group
            v-model="ruleForm.farmProduceType"
            clearable
            @change="handRadio"
            class="wihe"
          >
            <el-radio :label="1">自我种植</el-radio>
            <el-radio :label="2">外部采购</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="入库数量" prop="toStockNum">
          <el-input
            v-model="ruleForm.toStockNum"
            @input="handleFarmNum"
            placeholder="请输入"
            class="wihe num_input"
          >
            <template slot="suffix">{{ ruleForm.toStockUnit }}</template>
          </el-input>
        </el-form-item>
        <el-form-item label="入库时间" prop="toStockTime">
          <el-date-picker
            type="date"
            placeholder="选择日期"
            v-model="ruleForm.toStockTime"
            :picker-options="pickerDateOptions"
            value-format="yyyy-MM-dd"
            :clearable="false"
            style="
               {
                width: 100%;
                width: 330px;
              }
            "
          ></el-date-picker>
        </el-form-item>
        <el-form-item
          label="外采公司名称"
          v-if="ruleForm.farmProduceType === 2"
          :rules="{
            required: true,
            message: '请选择或输入外采公司名称',
            trigger: 'change',
          }"
          class="wihe"
          prop="enterpriseName"
        >
          <el-autocomplete
            class="autocomplete"
            v-model.trim="ruleForm.enterpriseName"
            :fetch-suggestions="getCompanyList"
            placeholder="请选择或输入外采公司名称"
            clearable
            @select="handleSelect"
            @input="handleInput"
            @clear="clearFun"
            @blur="handleBlur"
          >
            <template slot-scope="{ item }">
              <div class="name">{{ item.enterpriseName }}</div>
              <span class="addr">{{ item.enterpriseAddress }}</span>
            </template>
          </el-autocomplete>
        </el-form-item>
        <el-form-item
          label="外采公司地址"
          :rules="{
            required: true,
            message: '请输入外采公司地址',
            trigger: 'change',
          }"
          prop="enterpriseAddress"
          v-if="ruleForm.farmProduceType == 2"
        >
          <el-input
            v-model="ruleForm.enterpriseAddress"
            :disabled="disabled"
            class="wihe"
            placeholder="请输入外采公司地址"
          ></el-input>
        </el-form-item>
        <el-form-item
          class="address"
          label="产地地址"
          v-if="ruleForm.farmProduceType == 2"
        >
          <div class="address_box" :class="errorAddress ? 'error_tips' : ''">
            <!-- 省 -->
            <el-select
              v-model="countyInfo.provinceId"
              @change="
                handSelect(
                  countyInfo.provinceId,
                  'market',
                  'provinceList',
                  'provinceName',
                  ['cityId', 'countyId']
                )
              "
              class="small_wihe"
              placeholder="省"
              @clear="
                clearDataFun([
                  'cityId',
                  'cityName',
                  'countyId',
                  'countyName',
                  'provinceName',
                ])
              "
              clearable
            >
              <el-option
                v-for="({ areaName, id }, index) in provinceList"
                :key="index"
                :label="areaName"
                :value="id"
              ></el-option>
            </el-select>
            <!-- 市 -->
            <el-select
              v-model="countyInfo.cityId"
              @change="
                handSelect(countyInfo.cityId, 'area', 'market', 'cityName', [
                  'countyId',
                ])
              "
              :disabled="!countyInfo.provinceId"
              class="small_wihe"
              placeholder="市"
              @clear="clearDataFun(['cityName', 'countyId', 'countyName'])"
              clearable
            >
              <el-option
                v-for="({ areaName, id }, index) in market"
                :key="index"
                :label="areaName"
                :value="id"
              ></el-option>
            </el-select>
            <!-- 区 -->
            <el-select
              v-model="countyInfo.countyId"
              @change="
                handSelect(countyInfo.countyId, '', 'area', 'countyName', [])
              "
              :disabled="!countyInfo.cityId"
              class="small_wihe"
              @clear="clearDataFun(['countyName'])"
              placeholder="区"
              clearable
            >
              <el-option
                v-for="({ areaName, id }, index) in area"
                :key="index"
                :label="areaName"
                :value="id"
              ></el-option>
            </el-select>
          </div>

          <!--  -->
          <el-input
            v-model="originMoreAddress"
            class="wihe origin_address"
            placeholder="请输入外采产品产地地址"
          ></el-input>
          <div class="error_tips" v-if="errorAddress">请选择产地地址</div>
        </el-form-item>
        <el-form-item label="单据、凭证照片">
          <div class="cert_item">
            <div
              class="img-list-item"
              v-for="(item, index) in ruleForm.cert"
              :key="index"
            >
              <el-image
                :src="setImgUrl(item, 100, 100)"
                :preview-src-list="ruleForm.cert"
                :initial-index="index"
              />
              <i class="el-icon-error" @click="removeImg(index)"></i>
            </div>
            <el-upload
              v-if="ruleForm.cert.length < 9"
              ref="upload"
              class="upload-img"
              list-type="picture-card"
              :action="uploadAction"
              accept=".jpg,.gif,.png,.jpeg,.bmp,.pdf,.GIF,.BMP,.JPG,.JPEG,.PNG"
              name="files"
              multiple
              :on-change="handleFileChange"
              :auto-upload="false"
              :show-file-list="false"
              v-loading="uploading"
            >
              <i class="el-icon-plus"></i>
              <p>上传照片</p>
            </el-upload>
          </div>
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            v-model="ruleForm.remarks"
            type="textarea"
            :rows="5"
            class="wihe"
            clearable
            placeholder="请输入"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="circulate_div" v-show="ruleForm.farmProduceType == 2">
        <div class="circulate_title">
          <span>流通环节信息</span>
          <el-button
            type="primary"
            size="small"
            @click="addDataFun"
            icon="el-icon-plus"
          >
            增加流通信息
          </el-button>
        </div>
        <div>
          <circulateItem
            v-for="(item, index) in circulateList"
            :key="index"
            :itemData="item"
            :index="index"
            :provinceList="provinceList"
            @backState="backState"
            @removeList="removeList"
          ></circulateItem>
        </div>
      </div>
      <div class="submit_div">
        <el-button
          :loading="loading"
          @click="submitForm('ruleForm')"
          type="primary"
        >
          保存
        </el-button>
      </div>
    </div>
  </MainLayout>
</template>
<script>
import axios from "axios";
import { snkd } from "@/api/api";
import { v4 as uuidv4 } from "uuid";
import MainLayout from "@/layout/MainLayout";
import { windowHref } from "@/utils";
import { getStorage } from "@/utils/storage";
import circulateItem from "./circulateItem.vue";
import { cropService } from "@/api/request/snkd.produce";
import originalSelect from "@/components/originalSelect";
import { getProvinceCityArea, upload } from "@/api/request/snkd.foundation";
import { setImgUrl } from "@/utils";
import {
  outsourcingInfoAdd,
  urlCompanyList,
  supplyEnterpriseAdd,
} from "@/api/request/snkd.produce";
import { numLimitCheck } from "@/utils";
export default {
  components: { MainLayout, circulateItem, originalSelect },
  data() {
    var validatePass = (rule, value, callback) => {
      setTimeout(() => {
        if (this.isShow) {
          callback();
        } else {
          if (this.ruleForm.cropId) {
            callback();
          } else {
            callback(new Error("请选择农产品"));
          }
        }
      }, 500);
    };
    return {
      ruleForm: {
        farmProduceType: 1,
        cropId: "",
        cropName: "",
        toStockNum: "",
        toStockTime: new Date().format("yyyy-MM-dd"),
        farmId: "",
        companyId: "",
        remarks: "",
        cert: [],
        toStockUnit: "",
        subjectIdentifier: "",
        enterpriseAddress: "",
        enterpriseName: "",
        enterpriseId: "",
      },
      rules: {
        cropId: [
          { required: true, validator: validatePass, trigger: "change" },
        ],
        farmProduceType: [
          { required: true, message: "请选择入库类型", trigger: "change" },
        ],
        toStockNum: [
          { required: true, message: "请输入入库数量", trigger: "change" },
        ],
        toStockTime: [
          { required: true, message: "请选择入库时间", trigger: "change" },
        ],
      },
      loading: false,
      option: [],
      uploadAction: snkd.foundation.file.upload,
      uploading: false,
      circulateList: [
        {
          cityId: "",
          cityName: "",
          contac: "",
          contactsTel: "",
          countyId: "",
          countyName: "",
          name: "",
          provinceId: "",
          provinceName: "",
          state: "",
        },
      ],
      // 省数据
      provinceList: [],
      buttonStateList: [],
      info: getStorage("FARMINFO"),
      options: [],
      selectLoading: false,
      fileObj: {},
      pickerDateOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      disabled: false,
      fileLength: 0,
      isShow: false,
      countyInfo: {
        cityId: "",
        cityName: "",
        countyId: "",
        countyName: "",
        provinceName: "",
        provinceId: "",
      },
      //   省
      province: [],
      //   市
      market: [],
      //   区
      area: [],
      errorAddress: false,
      originMoreAddress: "",
    };
  },
  created() {
    const { companyId, farmId } = this.info;
    this.getOption();
    this.getProvinceOption();
    this.ruleForm.farmId = farmId;
    this.ruleForm.companyId = companyId;
  },
  methods: {
    setImgUrl,
    goBack() {
      const { companyId, farmId } = this.info;
      windowHref("/agriproductstorage/list", {
        companyId,
        farmId,
        inoutType: 2,
      });
    },
    addDataFun() {
      const arry = this.buttonStateList.filter((item) => item.state);
      if (arry.length != this.circulateList.length) {
        return this.$message({
          message: "流通信息至少填写一项内容才可新增下一条！",
          type: "warning",
        });
      }
      this.circulateList.push({
        cityId: "",
        cityName: "",
        contac: "",
        contactsTel: "",
        countyId: "",
        countyName: "",
        name: "",
        provinceId: "",
        provinceName: "",
        state: "",
      });
    },
    // 上传发生变化钩子
    async handleFileChange(file) {
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isLt10M) {
        this.$message.error("图片上传大小不超过10MB");
        return false;
      }
      if (this.fileLength >= 9) {
        this.$message.info("图片最多上传9张");
        return false;
      }
      this.fileLength = this.fileLength + 1;
      await this.submitFileForm(file);
    },
    // 提交上传文件
    async submitFileForm(file) {
      let formData = new FormData();
      const dir = "snkoudai/web/";
      const fileType = file.raw["type"];
      const index = fileType.lastIndexOf("/") + 1;
      const fileFormat = fileType.substring(index, fileType.length);
      var fileName = `${uuidv4()}.${fileFormat}`;
      formData.append("file", file.raw);
      formData.append("folderPath", dir);
      formData.append("originalFilename", fileName);
      this.uploading = true;
      await upload(formData)
        .then((res) => {
          const uploadRet = res && res.obj && res.obj.internetUrl;
          if (!uploadRet) return;
          this.ruleForm.cert.push(res.obj.internetUrl);
          this.uploading = false;
        })
        .catch(() => {
          this.$message.error("上传失败！");
          this.uploading = false;
        });
    },
    uploadFile(params) {
      this.uploading = true;
      return axios.post(this.uploadAction, params, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    },
    backState(parems) {
      const { i, state, allState } = parems;
      this.buttonStateList[i] = { state, allState, i };
    },
    removeList(i) {
      this.circulateList.splice(i, 1);
      this.buttonStateList.splice(i, 1);
    },
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (
          this.ruleForm.farmProduceType === 2 &&
          this.countyInfo.provinceId &&
          this.countyInfo.cityId &&
          this.countyInfo.countyId
        ) {
          this.errorAddress = false;
          if (valid) {
            try {
              this.loading = true;
              const { farmId, farmName } = this.info;
              const {
                enterpriseName,
                enterpriseAddress,
                farmProduceType,
                enterpriseId,
              } = this.ruleForm;
              const body = {
                enterpriseName:
                  farmProduceType === 1 ? farmName : enterpriseName,
                enterpriseAddress,
                isHide: 0,
                source: 0,
                type: farmProduceType,
                farmId,
              };
              if (enterpriseId) {
                body.enterpriseId = enterpriseId;
              }
              const {
                obj: { id },
              } = await supplyEnterpriseAdd(body);
              this.ruleForm.enterpriseId = id;
              this.confirmFun();
            } catch (error) {
              console.log(error);
            } finally {
              this.loading = false;
            }
          } else {
            console.log("error submit!!");
            return false;
          }
        } else {
          this.errorAddress = true;
        }
        if (this.ruleForm.farmProduceType === 1) {
          if (valid) {
            try {
              this.loading = true;
              const { farmId, farmName } = this.info;
              const {
                enterpriseName,
                enterpriseAddress,
                farmProduceType,
                enterpriseId,
              } = this.ruleForm;
              const body = {
                enterpriseName:
                  farmProduceType == 1 ? farmName : enterpriseName,
                enterpriseAddress,
                isHide: 0,
                source: 0,
                type: farmProduceType,
                farmId,
              };
              if (enterpriseId) {
                body.enterpriseId = enterpriseId;
              }
              const {
                obj: { id },
              } = await supplyEnterpriseAdd(body);
              this.ruleForm.enterpriseId = id;
              this.confirmFun();
            } catch (error) {
              console.log(error);
            } finally {
              this.loading = false;
            }
          } else {
            console.log("error submit!!");
            return false;
          }
        }
      });
    },
    datechack() {
      const { cert, farmProduceType } = this.ruleForm;
      let text = "";
      let state = false;
      if (farmProduceType == 1) {
        if (!cert.length) {
          text =
            "依据《农产品质量安全法》相关规定，现所有外采的农产品应上传采收凭证并附加承诺达标合格证标识，您当前还未上传相应证明，是否确认保存当前外采信息。";
          state = false;
        } else {
          text = "";
          state = true;
        }
      }
      if (farmProduceType == 2) {
        let firstState = this.buttonStateList.length
          ? this.buttonStateList[0].allState
          : false;
        if (firstState && cert.length) {
          state = true;
          text = "";
        } else if (!cert.length && firstState) {
          state = false;
          text =
            "依据《农产品质量安全法》相关规定，现所有外采的农产品应上传采收凭证、流通环节相关信息并附加承诺达标合格证标识，您当前还未上传相应证明，是否确认保存当前外采信息。";
        } else if (cert.length && !firstState) {
          text =
            "依据《农产品质量安全法》相关规定，现所有外采的农产品应上传采收凭证、流通环节相关信息并附加承诺达标合格证标识，您当前还未填写流通环节相关信息，是否确认保存当前外采信息。";
          state = false;
        } else if (!cert.length && !firstState) {
          text =
            "依据《农产品质量安全法》相关规定，现所有外采的农产品应上传采收凭证、流通环节相关信息并附加承诺达标合格证标识，您当前还未填写流通环节相关信息、证明照片，是否确认保存当前外采信息。";
          state = false;
        }
      }
      return {
        text,
        state,
      };
    },
    confirmFun() {
      const { state, text } = this.datechack();
      if (state) return this.addWarehousing();
      this.$confirm(text, "提醒", {
        confirmButtonText: "保存",
        cancelButtonText: "取消",
        dangerouslyUseHTMLString: true,
      })
        .then(() => {
          this.addWarehousing();
        })
        .catch(() => {});
    },
    async addWarehousing() {
      try {
        const { cert, farmProduceType, enterpriseName } = this.ruleForm;
        const { farmName } = this.info;
        const body = {
          ...this.ruleForm,
          cert: cert.length ? cert.join(",") : "",
          userId: localStorage.getItem("USERID"),
          enterpriseName: farmProduceType == 2 ? enterpriseName : farmName,
          circulateInfoList:
            farmProduceType == 2
              ? this.circulateList.filter((item) => item.state)
              : [],
          toStockAddress: {
            provinceId: this.countyInfo.provinceId,
            provinceName: this.countyInfo.provinceName,
            cityId: this.countyInfo.cityId,
            cityName: this.countyInfo.cityName,
            countyId: this.countyInfo.countyId,
            countyName: this.countyInfo.countyName,
            detailAddress: this.originMoreAddress,
          },
        };
        const { respCode } = await outsourcingInfoAdd(body);
        if (!respCode) {
          this.$message({
            type: "info",
            message: "农产品入库成功",
          });
          setTimeout(() => {
            this.goBack();
          }, 1000);
        }
      } catch (error) {
        console.log(error);
      }
    },
    async addOption(val, backFun) {
      try {
        const { companyId, farmId } = this.info;
        await cropService.addFeedback({
          companyId,
          farmId,
          cropName: val,
        });
        backFun(true);
      } catch (error) {
        backFun(false);
      } finally {
        this.getOption();
      }
    },
    async getCompanyList(val, cb) {
      this.selectLoading = true;
      try {
        const { farmId } = this.info;
        const {
          obj: { list },
        } = await urlCompanyList({
          farmId,
          keyword: val,
          pageNo: 1,
          source: 0,
          pageSize: 50,
        });
        this.options = list.map((list) => ({
          value: list.enterpriseName,
          ...list,
        }));
        cb(this.options);
      } catch (error) {
        console.log(error);
      } finally {
        this.selectLoading = false;
      }
    },
    handleSelect(val) {
      const { enterpriseName, enterpriseAddress, id } = val;
      this.ruleForm.enterpriseName = enterpriseName;
      this.ruleForm.enterpriseAddress = enterpriseAddress;
      this.ruleForm.enterpriseId = id;
      this.disabled = true;
    },
    handleInput() {
      this.disabled = false;
      this.ruleForm.enterpriseAddress = "";
      this.ruleForm.enterpriseId = "";
    },
    handleBlur() {
      const filterItems = this.options.filter((i) => {
        return i.enterpriseName === this.ruleForm.enterpriseName;
      });
      if (filterItems.length) {
        const { enterpriseName, enterpriseAddress, id } = filterItems[0];
        this.ruleForm.enterpriseName = enterpriseName;
        this.ruleForm.enterpriseAddress = enterpriseAddress;
        this.ruleForm.enterpriseId = id;
        this.disabled = true;
      }
    },
    clearFun() {
      this.ruleForm.enterpriseName = "";
      this.ruleForm.enterpriseAddress = "";
      this.ruleForm.enterpriseId = "";
      this.disabled = false;
    },
    async getOption() {
      const { companyId } = this.info;
      this.loading = true;
      try {
        const { list } = await cropService.listAllShort({ companyId });
        this.option = list;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async getProvinceOption() {
      try {
        const {
          obj: { list },
        } = await getProvinceCityArea({ parentId: 0 });
        this.provinceList = list;
      } catch (error) {
        console.log(error);
      }
    },
    backObjData(params) {
      if (!params) return;
      const { cropName, cropSubjectIdentifier, cropCategoryUnit } = params;
      this.ruleForm.cropName = cropName;
      this.ruleForm.subjectIdentifier = cropSubjectIdentifier;
      if (
        cropSubjectIdentifier === "agri" ||
        cropSubjectIdentifier === "fishery"
      ) {
        this.ruleForm.toStockUnit = "公斤";
      } else {
        this.ruleForm.toStockUnit = cropCategoryUnit;
      }
      this.ruleForm.toStockNum = "";
      this.$refs.ruleForm.validateField("cropId");
    },
    handleFarmNum() {
      const { toStockNum, subjectIdentifier } = this.ruleForm;
      if (toStockNum == "") return;
      if (toStockNum == 0) {
        this.$message({
          type: "warning",
          message: "仅可输入正数",
        });
      }
      if (Number(toStockNum) > 999999999) {
        this.$message({
          type: "warning",
          message: "入库数量最大为999999999",
        });
      }
      let dec = 0;
      if (subjectIdentifier) {
        dec =
          subjectIdentifier == "animal" || subjectIdentifier == "forestry"
            ? 0
            : 1;
      }
      this.ruleForm.toStockNum = numLimitCheck(toStockNum, 999999999, dec);
    },
    handRadio() {
      this.ruleForm.enterpriseId = "";
      this.ruleForm.enterpriseAddress = "";
      this.ruleForm.enterpriseName = "";
      this.originMoreAddress = "";
      this.errorAddress = false;
      [
        "cityId",
        "cityName",
        "countyId",
        "countyName",
        "provinceName",
        "provinceId",
      ].map((item) => {
        this.countyInfo[item] = "";
      });
      this.$refs.ruleForm.clearValidate(["cropId", "toStockNum"]);
    },
    removeImg(i) {
      this.ruleForm.cert.splice(i, 1);
      this.fileLength = this.fileLength - 1;
    },
    clearDataFun(params) {
      params.map((item) => {
        this.countyInfo[item] = "";
      });
    },
    async handSelect(val, option, selectoption, name, paremslist) {
      if (!val) return;
      this.countyInfo[name] = this[selectoption].filter(
        (item) => item.id == val
      )[0].areaName;
      try {
        const {
          obj: { list },
        } = await getProvinceCityArea({ parentId: val });
        this[option] = list;
      } catch (error) {
        console.log(error);
      } finally {
        if (paremslist.length) {
          this.clearDataFun(paremslist);
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.main-content {
  width: 1200px;
  min-height: calc(100vh - 120px);
  background: #ffffff;
  margin: 0 auto;
  padding: 30px 10px 10px;
}

.Outsourcing {
  padding: 56px 55px 0;

  ::v-deep .el-form-item {
    margin-bottom: 40px !important;
  }
}

.ruleForm .el-form-item {
  width: 50%;
  margin-right: 0px;
}

.address {
  // ::before {
  //   content: "*";
  //   color: #f56c6c;
  // }
}

.error_tips {
  color: #f56c6c;
  font-size: 12px;

  ::v-deep .el-input__inner {
    border-color: #f56c6c;
  }
}

.wihe {
  width: 330px;
}

.origin_address {
  margin-top: 5px;
}

.small_wihe {
  width: 100px;
  margin-right: 10px;
}

.circulate_div {
  border-top: 1px solid #e4e4e4;
  padding: 25px 40px 0;
}

.circulate_title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 14px;
}

.submit_div {
  width: 100%;
  text-align: center;
}

.img-list-item {
  width: 100px;
  height: 100px;
  margin-right: 20px;
  margin-bottom: 20px;
  position: relative;

  i {
    position: absolute;
    right: -15px;
    top: 0;
  }

  .el-image {
    width: 100%;
    height: 100%;
  }
}

::v-deep .el-input-group__append {
  background-color: #fff;
}

.select_width {
  width: 330px;
  display: block;
}

.cert_item {
  width: 360px;
  display: flex;
  flex-wrap: wrap;
}

.i_text {
  display: block;
  font-size: 12px;
}

.upload-img {
  position: relative;
  width: 100px;
  height: 100px;

  p {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 20px;
    text-align: center;
    color: #ccc;
    font-size: 12px;
    box-sizing: border-box;
    padding-top: 0;
  }

  i {
    color: #dcdfe6;
    position: absolute;
    font-size: 20px;
    left: 40px;
    top: 30px;
  }

  ::v-deep .el-upload--picture-card {
    width: 100%;
    height: 100%;
  }
}

.autocomplete {
  width: 300px;
}

.addr {
  color: #ccc;
  font-size: 12px;
}
</style>

<style lang="scss">
.el-select-dropdown__item {
  height: auto;
}

.el-message-box__title {
  span {
    font-weight: bold;
  }
}
</style>
